import { z } from 'zod';
// ============================================================
// RSVP Schemas
// ============================================================
export const AttendanceStatusSchema = z.enum([
    'ATTENDING',
    'NOT_ATTENDING',
    'MAYBE',
]);
export const MealOptionSchema = z.enum(['ADULT', 'CHILD', 'VEGETARIAN', 'NONE']);
export const RSVPSchema = z.object({
    id: z.string().cuid2(),
    invitationId: z.string().cuid2(),
    guestName: z.string().max(255),
    guestPhone: z.string().max(500).nullable(),
    guestEmail: z.string().max(500).nullable(),
    attendance: AttendanceStatusSchema,
    guestCount: z.number().int().min(1).max(10).default(1),
    mealOption: MealOptionSchema.nullable(),
    message: z.string().nullable(),
    submittedAt: z.date(),
});
// ============================================================
// API Request/Response
// ============================================================
export const SubmitRSVPRequestSchema = z.object({
    invitationId: z.string().cuid2(),
    guestName: z
        .string()
        .min(1, '이름을 입력하세요')
        .max(255, '이름은 255자를 초과할 수 없습니다'),
    guestPhone: z
        .string()
        .regex(/^01[0-9]-?[0-9]{3,4}-?[0-9]{4}$/, '올바른 전화번호를 입력하세요')
        .optional()
        .transform((val) => val?.replace(/-/g, '')),
    guestEmail: z.string().email('올바른 이메일을 입력하세요').optional(),
    attendance: AttendanceStatusSchema,
    guestCount: z
        .number()
        .int()
        .min(1, '최소 1명 이상이어야 합니다')
        .max(10, '최대 10명까지 가능합니다')
        .default(1),
    mealOption: MealOptionSchema.optional(),
    message: z.string().max(500, '메시지는 500자를 초과할 수 없습니다').optional(),
});
export const RSVPResponseSchema = RSVPSchema.omit({
    guestPhone: true,
    guestEmail: true,
}).extend({
    guestPhoneMasked: z.string().optional(),
    guestEmailMasked: z.string().optional(),
});
export const RSVPStatsResponseSchema = z.object({
    total: z.number().int().min(0),
    attending: z.number().int().min(0),
    notAttending: z.number().int().min(0),
    maybe: z.number().int().min(0),
    totalGuests: z.number().int().min(0),
    mealStats: z.object({
        adult: z.number().int().min(0),
        child: z.number().int().min(0),
        vegetarian: z.number().int().min(0),
        none: z.number().int().min(0),
    }),
});
export const RSVPListResponseSchema = z.object({
    rsvps: z.array(RSVPResponseSchema),
    stats: RSVPStatsResponseSchema,
    invitationId: z.string().cuid2(),
});
// ============================================================
// Validation Helpers
// ============================================================
export const maskPhoneNumber = (phone) => {
    const cleaned = phone.replace(/-/g, '');
    if (cleaned.length === 11) {
        return `${cleaned.slice(0, 3)}-****-${cleaned.slice(-4)}`;
    }
    return '***-****-****';
};
export const maskEmail = (email) => {
    const [local, domain] = email.split('@');
    if (!local || !domain)
        return '***@***';
    const maskedLocal = local[0] + '***';
    return `${maskedLocal}@${domain}`;
};
export const isValidKoreanPhone = (phone) => {
    const cleaned = phone.replace(/-/g, '');
    return /^01[0-9]{8,9}$/.test(cleaned);
};
//# sourceMappingURL=rsvp.js.map